export default function Go() {
  return <div>No need to schedule an appointment</div>;
}
